export function groupRoomsByCoords(
  rooms: Array<{
    latitude: number;
    longitude: number;
  }>,
) {
  const groups = rooms.reduce((acc, room) => {
    const id = `${room.latitude}-${room.longitude}`;

    return {
      ...acc,
      [id]: {
        ...acc[id],
        id,
        latitude: room.latitude,
        longitude: room.longitude,
        rooms: (acc[id] ? acc[id].rooms : []).concat(room),
      },
    };
  }, {});

  return Object.values(groups);
}
